import { render, staticRenderFns } from "./RepairInfo.vue?vue&type=template&id=0d4a0f25&scoped=true"
import script from "./RepairInfo.vue?vue&type=script&lang=js"
export * from "./RepairInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a0f25",
  null
  
)

export default component.exports